export default "/images/vendor/flag-icon-css/flags/4x3/mr.svg?b54c9b3dd9d9bd0d450edfb3ed16c521";